import Microgame from '../engine/Microgame.js';

export default class ShakeGame extends Microgame {

    static getPlayback() {
        return {
            title: { fr: 'Shake !', en: 'Shake!', es: '¡Agita!' },
            controls: { fr: 'Secoue ton téléphone, ou frotte frénétiquement l\'écran/souris', en: 'Shake your phone, or rapidly swipe screen/mouse', es: 'Agita tu teléfono o desliza rápidamente' },
            objective: { fr: 'Remplis la barre d\'énergie avant la fin du temps', en: 'Fill the energy bar before time runs out', es: 'Llena la barra de energía antes de que acabe el tiempo' },
            icon: `<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="var(--primary-color)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 14a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-6Z"></path><path d="M12 12V2"></path><path d="m8 6 4-4 4 4"></path><path d="M4 18h.01"></path><path d="M8 18h.01"></path><path d="M12 18h.01"></path><path d="M16 18h.01"></path><path d="M20 18h.01"></path></svg>`,
            actions: [
                { type: 'move', x: 35, y: 55, duration: 220 },
                { type: 'swipe', fromX: 35, fromY: 55, toX: 65, toY: 45, duration: 180 },
                { type: 'swipe', fromX: 65, fromY: 45, toX: 35, toY: 60, duration: 180 },
                { type: 'swipe', fromX: 35, fromY: 60, toX: 68, toY: 42, duration: 180 },
                { type: 'wait', duration: 320 },
            ],
            loopDuration: 3000
        };
    }
    constructor(engine) {
        super(engine);
        this.shakeAmount = 0;

        // --- GAME PARAMETERS ---
        this.duration = 4000; // Base time in ms
        this.baseRequiredShake = 3000; // Total distance needed to win at base speed
        // -----------------------

        this.lastX = 0;
        this.lastY = 0;
        this.bar = null;
        this.fill = null;
    }

    setup() {
        this.engine.ui.instruction.textContent = "SHAKE!";

        // Scale required shake distance based on actual time available
        // At max speed (x4), time is ~1000ms, so requiredShake becomes ~500px, which is doable.
        const timeRatio = this.engine.maxTime / this.duration;
        this.requiredShake = Math.max(400, this.baseRequiredShake * timeRatio);

        // Visual Container
        const container = document.createElement('div');
        container.style.position = 'absolute';
        container.style.top = '50%';
        container.style.left = '50%';
        container.style.transform = 'translate(-50%, -50%)';
        container.style.textAlign = 'center';
        this.container.appendChild(container);

        // Icon
        // Icon (Neon Phone)
        const icon = document.createElement('div');
        icon.style.width = '60px';
        icon.style.height = '100px';
        icon.style.border = `4px solid ${this.primaryColor}`;
        icon.style.borderRadius = '10px';
        icon.style.boxShadow = `0 0 15px ${this.primaryColor}, inset 0 0 15px ${this.primaryColor}`;
        icon.style.margin = '0 auto';
        icon.style.position = 'relative';
        icon.style.animation = 'shake 0.2s infinite';

        // Phone Screen
        const screen = document.createElement('div');
        screen.style.position = 'absolute';
        screen.style.top = '10px';
        screen.style.left = '50%';
        screen.style.transform = 'translateX(-50%)';
        screen.style.width = '40px';
        screen.style.height = '60px';
        screen.style.border = `2px solid ${this.secondaryColor}`;
        screen.style.borderRadius = '4px';
        screen.style.opacity = '0.8';
        icon.appendChild(screen);

        // Home Button
        const btn = document.createElement('div');
        btn.style.position = 'absolute';
        btn.style.bottom = '5px';
        btn.style.left = '50%';
        btn.style.transform = 'translateX(-50%)';
        btn.style.width = '10px';
        btn.style.height = '10px';
        btn.style.borderRadius = '50%';
        btn.style.background = this.primaryColor;
        btn.style.boxShadow = `0 0 5px ${this.primaryColor}`;
        icon.appendChild(btn);

        container.appendChild(icon);

        // Progress Bar
        this.bar = document.createElement('div');
        this.bar.style.width = '200px';
        this.bar.style.height = '20px';
        this.bar.style.background = '#333';
        this.bar.style.borderRadius = '10px';
        this.bar.style.marginTop = '20px';
        this.bar.style.overflow = 'hidden';
        this.bar.style.border = '2px solid #fff';
        container.appendChild(this.bar);

        this.fill = document.createElement('div');
        this.fill.style.width = '0%';
        this.fill.style.height = '100%';
        this.fill.style.background = this.secondaryColor;
        this.fill.style.boxShadow = `0 0 10px ${this.secondaryColor}`;
        this.bar.appendChild(this.fill);

        // Events
        this.onMove = this.onMove.bind(this);
        this.engine.input.element.addEventListener('mousemove', this.onMove);
        this.engine.input.element.addEventListener('touchmove', this.onMove);
    }

    onMove(e) {
        if (!this.active) return;

        let x, y;
        if (e.touches) {
            x = e.touches[0].clientX;
            y = e.touches[0].clientY;
        } else {
            x = e.clientX;
            y = e.clientY;
        }

        if (this.lastX !== 0 && this.lastY !== 0) {
            const dist = Math.hypot(x - this.lastX, y - this.lastY);
            this.shakeAmount += dist;

            const pct = Math.min(100, (this.shakeAmount / this.requiredShake) * 100);
            this.fill.style.width = `${pct}%`;

            if (this.shakeAmount >= this.requiredShake) {
                this.win();
            }
        }

        this.lastX = x;
        this.lastY = y;
    }

    cleanup() {
        super.cleanup();
        this.engine.input.element.removeEventListener('mousemove', this.onMove);
        this.engine.input.element.removeEventListener('touchmove', this.onMove);
    }
}
